export const SET_COUNTIES = "COUNTIES/SET_COUNTIES";
export const SET_COUNTY = "COUNTIES/SET_COUNTY";
export const SET_PAGINATION = "COUNTIES/SET_PAGINATION";
